var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "upload-card-white"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "upload-row-inline"
  }, [_c('div', {
    staticClass: "field-group"
  }, [_c('label', {
    staticClass: "upload-label"
  }, [_vm._v("Upload CSV:")]), _vm._v(" "), _c('div', {
    staticClass: "file-select"
  }, [_c('input', {
    ref: "fileInput",
    attrs: {
      "type": "file",
      "accept": ".csv"
    },
    on: {
      "change": _vm.handleFileChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "file-chosen"
  }, [_vm._v("\n              " + _vm._s(_vm.selectedFile ? _vm.selectedFile.name : "No file chosen") + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "field-group intimation-block"
  }, [_c('label', {
    staticClass: "intimation-label"
  }, [_vm._v("Intimation for:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Intimation),
      expression: "Intimation"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        max: 500
      }),
      expression: "{ required: true, max: 500 }"
    }],
    staticClass: "form-control intimation-textarea",
    attrs: {
      "rows": "1"
    },
    domProps: {
      "value": (_vm.Intimation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Intimation = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "helper-text"
  }, [_vm._v("Maximum length 500 characters.")])]), _vm._v(" "), _c('button', {
    staticClass: "upload-btn-small",
    attrs: {
      "disabled": !_vm.selectedFile || _vm.uploading
    },
    on: {
      "click": _vm.uploadCsv
    }
  }, [(!_vm.uploading) ? _c('span', [_vm._v("Upload CSV")]) : _c('span', [_vm._v("Uploading...")])]), _vm._v(" "), _c('button', {
    staticClass: "reset-btn-small",
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Reset")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Intimation')),
      expression: "errors.has('Intimation')"
    }],
    staticClass: "error-text"
  }, [_vm._v("\n      Please enter Intimation For\n    ")])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header"
  }, [_c('legend', {
    staticClass: "title"
  }, [_vm._v("Bulk Auto NoInfo Shipments")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-92aaabb2","hasScoped":true}!./src/views/components/LOST/BulkAutoNotify/BulkAutoNotify.component.html
// module id = 1606
// module chunks = 1